﻿{
  "boardmakerHome": "Boardmaker Home",
  "subscription": "Abonnement",
  "change": "Changer",
  "currency": "USD",
  "save": "Enregistrer",
  "save17Percent": "<strong>Économisez {{percent}}%</strong> avec un forfait annuel",
  "save17PercentNoBold": "Économisez {{percent}}%",
  "yearly": "Une fois par an",
  "monthly": "Une fois par mois",
  "Lifetime": "À vie",
  "PerMonth": "Par mois",
  "PerYear": "Par an",
  "Free": "Libre",
  "optional": "facultatif",
  "trialLengthTrial": "<0>{{ trialLength }}</0>Essai de -jours",
  "viewAllPlans": "Voir tous les forfaits",
  "myBoardmaker": "My Boardmaker",
  "canada": "Canada",
  "unitedStates": "États-Unis",
  "oneMomentPlease": "Veuillez patienter un instant, s’il vous plaît...",
  "software": "Logiciel",
  "boardmakerStudio": "Boardmaker Studio",
  "boardmakerStudentCenter": "Boardmaker Student Center",
  "complete": "Terminé",
  "loadingRegions": "Chargement des régions disponibles en cours...",
  "loadingPartners": "Chargement des partenaires disponibles en cours...",
  "supportedPeripherals": "Périphériques pris en charge",
  "pleaseWait": "Veuillez patienter...",
  "minimum": "Minimum",
  "recommended": "Recommandé",
  "browser": "Navigateur",
  "tobiiDynavoxEyeTrackers": "Eye trackers Tobii Dynavox",
  "boardmaker7": "Boardmaker 7",
  "needHelpChoosing": "Besoin d’aide pour choisir",
  "or": "ou",
  "advantages": "Avantages",
  "visitPartnerSite": "Visiter le site du partenaire",
  "recentOrders": "Commandes récentes",
  "current": "en cours",
  "orLater": "ou plus tard",
  "customerSupport": "assistance client",
  "proratedAmount": "Montant proportionnel",
  "community": {
    "community": "Communauté",
    "getStartedNow": "Démarrer maintenant !"
  },
  "personal": "Privé",
  "professional": "Professionnel",
  "planCard": {
    "noCCRequired": "Aucune carte de crédit n’est requise",
    "cCOnly": "Carte de crédit uniquement",
    "cCOrPO": "Carte de crédit ou bon de commande",
    "myPlan": "Mon forfait",
    "currentPlan": "Forfait actuel",
    "downgradeNotice": "Les modifications prendront effet une fois que le forfait actuel sera terminé.",
    "upgradeNotice": "Les modifications prennent effet immédiatement"
  },
  "selectedPlanSummary": {
    "summary": "Récapitulatif",
    "change": "$T(change) (((",
    "subtotal": "Sous-total"
  },
  "action": {
    "joinToday": "Inscrivez-vous dès aujourd’hui !",
    "finish": "Terminer",
    "subscribe": "S'abonner",
    "resubscribe": "Se réabonner",
    "requestAQuote": "Demander un devis",
    "try": "Essayer",
    "startTrial": "Commencer l'essai",
    "buyNow": "Acheter maintenant",
    "tryIt": "L’essayer",
    "tryItFree": "L’essayer gratuitement pendant 30 jours !",
    "free": "gratuit",
    "getStarted": "Démarrer",
    "forTrialDays": "pendant <1>{{trialLength}}</1> jours",
    "comparePlans": "Tableau comparatif des forfaits",
    "hideComparisons": "Masquer tableau comparatif",
    "learnMore": "En savoir plus",
    "start": "Démarrer",
    "next": "Suivant",
    "edit": "Édition",
    "cancel": "Annuler",
    "imTaxExempt": "Exonération de taxes",
    "submit": "Envoyer",
    "print": "Imprimer",
    "backToPaymentDetails": "Revenir aux informations de paiement",
    "close": "Fermer",
    "back": "Arrière",
    "continue": "Continuer",
    "uploading": "Téléchargement en cours",
    "delete": "Supprimer",
    "update": "Mettre à jour",
    "generatingInvoice": "Création de la facture en cours",
    "proceed": "Effectuer le paiement",
    "modify": "Modifier",
    "yes": "Oui",
    "signUp": "Inscription",
    "downloads": "Téléchargements"
  },
  "status": {
    "loading": "Chargement...",
    "creatingAccount": "Création du compte en cours...",
    "submitting": "Soumission en cours...",
    "submittingPayment": "Soumission du paiement en cours...",
    "submittingRequest": "Soumission de la demande en cours..."
  },
  "planComparison": {
    "label": "Quels sont les avantages principaux de chaque forfait ?",
    "buttonShow": "$t(action.comparePlans)",
    "buttonHide": "$t(action.hideComparisons)",
    "header": "Tableau comparatif des avantages",
    "subheader": "La solution la plus populaire au monde pour créer des soutiens à la communication basés sur des symboles et visuels sans limites !"
  },
  "account": {
    "email": "E-mail",
    "accountFoundTitle": "Un compte a été trouvé",
    "accountFoundMessage": "Un compte utilisant cette adresse email existe déjà. Souhaitez-vous vous connecter à l’aide de ce compte ou utiliser une adresse e-mail différente et créer un nouveau compte ?",
    "signedOutElsewhereTitle": "Vous avez été déconnecté",
    "signedOutElsewhereMessage": "Vous avez été déconnecté dans un autre onglet. Reconnectez-vous pour continuer, ou fermez ce message pour continuer à naviguer sans compte.",
    "signedOutElsewhereDismiss": "Continuer la navigation",
    "federatedEmailTitle": "Adresse e-mail d’organisation détectée",
    "federatedEmailMessage": "Cette adresse e-mail utilise la connexion de votre organisation. Connectez-vous pour accéder à Boardmaker via votre organisation, ou utilisez une autre adresse e-mail pour créer un nouveau compte.",
    "federatedEmailUseDifferent": "Utiliser une autre adresse e-mail",
    "logIn": "Se connecter",
    "logOut": "Se déconnecter",
    "loggingIn": "Connexion en cours...",
    "loggingOut": "Déconnexion en cours...",
    "verifying": "Vérification en cours...",
    "loggingInMessage": "Connexion en cours...",
    "createAccount": "Créer un compte",
    "creatingAccount": "$t(status.creatingAccount)",
    "login1": "A déjà un ",
    "login2": "compte",
    "login3": "Tobii Dynavox",
    "loginPrompt": "Vous avez déjà un <1>compte Tobii Dynavox</1> ? <3>Se connecter</3>",
    "cancelSubscription": "Annuler la souscription",
    "areYouSure": "Voulez-vous vraiment sélectionner ce forfait ? Procéder aura pour résultat ce qui suit :",
    "cancelSubscriptionProcess": "Annuler le processus de souscription (votre état de progression sera perdu)",
    "changeToCommunityPlan": "Changer votre compte en forfait Communauté",
    "onceYouveCompletedYourProfile": "Si vous décidez d’améliorer votre forfait une fois votre profil complété, vous pouvez le faire à tout moment dans la section Mon compte.",
    "proceed": "$t(action.proceed)",
    "back": "$t(action.back)",
    "loadingUser": "Récupération des informations sur l’utilisateur en cours"
  },
  "requestaquote": {
    "fillOutDetailsBelow": "Veuillez remplir le formulaire ci-dessous et un gestionnaire de compte vous contactera rapidement.",
    "fillOutDetailsBelowLicense": "Veuillez remplir le formulaire ci-dessous et un conseiller commercial vous contactera rapidement."
  },
  "forms": {
    "confirmEmail": "Confirmez votre adresse e-mail",
    "billingDetails": "Informations de facturation",
    "paymentType": "Type de paiement",
    "creditCardType": "Type de paiement",
    "creditCard": "Carte de crédit",
    "purchaseOrder": "Bon de commande",
    "cardNumber": "Numéro de carte",
    "expirationDate": "Date d’expiration",
    "cardholderName": "Nom du titulaire de la carte",
    "cardSecurityCode": "Code de sécurité de la carte",
    "securityCode": "Code de sécurité",
    "organizationName": "Nom de l'organisation",
    "accountsPayableEmail": "Email du compte",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "addressLine": "Ligne d'adresse 1",
    "addressLine2": "Ligne d'adresse 2",
    "country": "Pays",
    "language": "Langue",
    "city": "Ville",
    "stateProvinceRegion": "États/ Province/ Région",
    "zipPostalCode": "Code postal",
    "month": "Mois",
    "year": "Année",
    "optional": "facultatif",
    "username": "Nom d'utilisateur",
    "name": "Nom",
    "phoneNumber": "Numéro de téléphone",
    "phone": "Téléphone",
    "email": "E-mail",
    "url": "URL :",
    "selectYourCountry": "Sélectionnez votre pays",
    "selectYourState": "Sélectionnez votre état",
    "selectYourProvinceTerritory": "Sélectionnez votre province ou territoire",
    "selectYourTerm": "Sélectionnez votre durée",
    "1year": "1 an",
    "2years": "2 ans",
    "3years": "3 ans",
    "4years": "4 ans",
    "5years": "5 ans",
    "instructorLogins": "Nombre de connexions instructeurs",
    "studentLogins": "Nombre de connexions élèves",
    "term": "Échéance",
    "tradeIn": "Pouvez-vous bénéficier d’une remise ?",
    "legacyVersions": "Possédez-vous des anciennes versions de Boardmaker à échanger contre une remise sur le prix de myBoardmaker ?",
    "selectAResponse": "Sélectionnez une réponse",
    "yes": "Oui",
    "no": "Non",
    "notSure": "Pas sûr",
    "password": "Mot de passe",
    "confirmPassword": "Confirmer le mot de passe",
    "additionalInformationOrQuestions": "Informations ou questions supplémentaires",
    "countryNotSupported": "---",
    "uploadDocument": "Télécharger un document",
    "chooseFile": "Choisir un fichier",
    "paymentMethod": "Méthode de paiement",
    "purchaseOrdersAreOnlyProcessed": "Les bons de commande ne sont traités qu’une fois que votre commande a été soumise. Ils peuvent donc être modifiés à tout moment avant cela.",
    "PONumber": "Numéro du bon de commande",
    "PONotes": "Notes à ajouter à la commande",
    "iVerifyThatImAuthorized": "Je confirme que je suis autorisé(e) à soumettre ce bon de commande",
    "submissionSuccessful": "Soumission réussie !",
    "thankYourForYourRequest": "Nous vous remercions pour votre demande ! Un gestionnaire de compte vous contactera très prochainement.",
    "ccExpDateFormat": "MM/YYYY",
    "numberOfLicenses": "Nombre de licences",
    "pleaseEnterYourName": "Veuillez saisir votre nom exactement tel qu'il apparaît sur la carte",
    "needHelpFindingSecurityCode": "Vous avez besoin d'aide pour trouver le code de sécurité de votre carte"
  },
  "validation": {
    "required": "Requis",
    "invalidEmail": "Adresse e-mail non valide",
    "emailsMustMatch": "Les adresse e-mail doivent correspondre",
    "passwordsMustMatch": "Les mots de passe doivent correspondre",
    "errorOccurred": "Une erreur s’est produite lors de la soumission du formulaire",
    "tryAgain": "Réessayez. Si le problème persiste, contactez l’assistance.",
    "errorOccurredPDF": "Une erreur s’est produite lors du chargement de la facture au format PDF",
    "password": {
      "minLength": "Le mot de passe doit contenir au moins 8 caractères.",
      "tooShort": "Trop court",
      "checking": "Vérification en cours..."
    },
    "invalidCardNumber": "Numéro de carte non valide",
    "invalidCardType": "Type de carte non valide",
    "invalidExpirationDate": "Date d’expiration non valide",
    "invalidSecurityCode": "Code de sécurité non valide",
    "securityCodeNumericWarning": "Le code de sécurité ne peut contenir que des chiffres",
    "invalidUsernameWarning": "Nom d’utilisateur non valide. Il ne peut contenir que des lettres et des chiffres.",
    "usernameMaxLengthWarning": "Le nom d’utilisateur ne peut dépasser 60 caractères.",
    "badZip": "Le code postal saisi n’est pas valide pour l’état sélectionné.",
    "badPostalCode": "Le code postal saisi n’est pas valide pour la province ou le territoire sélectionné.",
    "canadianAddressNeedsCad": "Les adresses de facturation canadiennes sont facturées en dollars canadiens. Pour continuer, sélectionnez le drapeau en haut de la page, puis choisissez Canada.",
    "USZipCode": "Vous devez saisir un code postal situé aux États-Unis",
    "CAZipCode": "Vous devez saisir un code postal situé aux Canada"
  },
  "invoice": {
    "communityHeader": "Aucune carte de crédit. Accès gratuit à myBoardmaker Community uniquement Conserver vos données et votre état de progression actuels au cas où vous décideriez d’opter pour une souscription payante. N’attendez-plus !",
    "trialHeader": "Aucune restriction. Aucune carte de crédit. Conserver vos données et votre état de progression actuels au cas où vous décideriez de passer de l’essai gratuit à une souscription payante. N’attendez-plus !",
    "plan": "Forfait",
    "term": "Échéance",
    "price": "Prix",
    "billingDetails": "$t(forms.billingDetails)",
    "paymentDetails": "Informations sur le paiement",
    "endingWith": "Se termine par",
    "expires": "Expire",
    "orderSummary": "Récapitulatif de la commande",
    "orderDate": "Date de la commande",
    "orderNumber": "Numéro de la commande",
    "subtotal": "$t(selectedPlanSummary.subtotal)",
    "tax": "Taxes",
    "total": "Total",
    "aConfirmationEmail": "Un e-mail de confirmation de commande a été envoyé à",
    "printOrderSummary": "Imprimer le récapitulatif de la commande",
    "recurringPaymentDisclaimer": "Votre commande comporte un <strong>paiement récurrent</strong> d’un montant de <3>{{amount}}</3>. Ce paiement sera renouvelé le <5>{{date, LL}}</5>.",
    "firstPaymentDisclaimer": "Nous vous facturerons <strong>{{amount}}</strong> le <strong>{{date}}</strong>, au début de votre nouvelle souscription.",
    "PODisclaimer": "Votre souscription est maintenant active et prête à être utilisée. Pour éviter toute interruption de service, nous devons avoir reçu votre paiement dans un délai de <strong>30 jours</strong>. Si aucun paiement n’est reçu avant le <4>{{date, LL}}</4>, votre compte deviendra un compte communauté gratuit jusqu’à ce que votre solde soit payé.",
    "purchaseOrderNumber": "Numéro du bon de commande",
    "orgNotes": "Notes à ajouter à la commande",
    "pleaseSendACopyOfYourInvoice": "Veuillez envoyer votre règlement et une copie de votre facture à :",
    "ifYourPurchaseOrdersReady": "Si votre bon de commande est prêt, vous pouvez le télécharger maintenant.",
    "supportedFileTypes": "Types de fichiers pris en charge ; .pdf, .jpg, .jpeg, .tif, .tiff, .png",
    "whenTheTimeComes": " Au moment venu, nous enverrons un e-mail à l’adresse <1>{{email}}</1> pour vous rappeler la date à laquelle votre prochain paiement doit être effectué.",
    "uploadSuccessful": "Téléchargement réussi !",
    "yourAccountWillContinue": "Nous vous remercions pour votre commande. En cas de renouvellement d’abonnement, le traitement de votre commande peut prendre jusqu’à 14 jours. Une fois votre commande terminée, vous recevrez un e-mail de confirmation ainsi que votre facture.",
    "billing": "Adresse de facturation",
    "payment": "Méthode de paiement",
    "ifYourPurchaseOrderIsReady": "Si votre bon de commande est prêt, vous pouvez le télécharger maintenant.",
    "PODisclaimer1": "Votre souscription est maintenant active et prête à être utilisée.",
    "PODisclaimer2": "Le paiement doit avoir été reçu dans un délai de 30 jours ou votre compte sera automatiquement converti en compte communauté gratuit.",
    "POStartsLaterDisclaimer": "Nous vous enverrons votre facture le <strong>{{date}}</strong>, au début de votre nouvelle souscription. Le paiement est dû dans les 30 jours suivant cette date."
  },
  "legal": {
    "privacyPolicy": "Politique de confidentialité",
    "studentPolicy": "Politique relative aux données des apprenants",
    "termsAndConditions": "Conditions générales",
    "termsOfService": "Conditions de service",
    "tdTermsAndConditions": "J’accepte les <1>$t(legal.termsAndConditions) de Tobii Dynavox</1>",
    "contactUs": "Nous contacter"
  },
  "errors": {
    "error": "Erreur",
    "loadingPlans": "Chargement des forfaits en cours",
    "sorry": "Nous sommes désolés... Le problème ne vient pas de vous, mais de nous",
    "somethingWentWrong": "Un problème s’est produit de notre côté. Nous avons enregistré cette erreur et vous prions de <1>{{link}}</1> si vous rencontrez ce problème à nouveau.",
    "tryGoingBack": "Essayez de revenir à la page précédente <1>{{link}}</1>",
    "downloadList": "Impossible de télécharger la liste de téléchargement."
  },
  "404": {
    "sorry": "Nous sommes désolés... Nous n’avons pas pu trouver la page",
    "oldLink": "Il peut s'agir d’un ancien lien ou il est possible qu’elle ait été supprimée.",
    "tryGoingBack": "$t(errors.tryGoingBack)"
  },
  "trial": {
    "getStartedNow": "Commencez votre essai gratuit dès maintenant !",
    "startYourFreeTrial": "Commencez votre essai gratuit",
    "todayWhichIncludesAccessForThirtyDays": " aujourd’hui. Cet essai comprend un accès pendant 30 jours !"
  },
  "navigation": {
    "bmoRedirect": "Vous êtes redirigé vers myBoardmaker..."
  },
  "expired": {
    "expiredTrialText": "Nous espérons que vous avez apprécié votre essai sans restriction de 30 jours. Votre essai a été converti en forfait communauté gratuit et toutes vos données et votre état de progression* ont été enregistrés. Pour accéder aux fonctionnalités haut de gamme disponibles pendant votre essai, il vous suffit d’opter pour une souscription mensuelle ou annuelle.",
    "dataAndProgress": "* Les données et l’état de progression contenus dans les fonctionnalités haut de gamme ne sont accessibles qu’avec une souscription payante complète."
  },
  "currencySelector": {
    "header": "Sélectionnez votre pays et langue",
    "disclaimer": {
      "USD": "Si votre pays ne figure pas dans la liste, veuillez sélectionner États-Unis d’Amérique."
    }
  },
  "taxExempt": {
    "us&ca": "États-Unis et Canada uniquement",
    "taxExemptionProgram": "Soumettez vos documents d’exonération de taxes à l’aide de ce formulaire. Nous vous contacterons par e-mail dans un délai de 3 jours ouvrés afin de vous confirmer votre statut d’exonération de taxes. Après avoir reçu l’e-mail de confirmation, vous pourrez passer votre commande exonérée de taxes. Si vous passez votre commande avant d’avoir reçu l’email de confirmation, vous devrez payer des taxes non remboursables.",
    "taxExemptionProgramExisting": "Soumettez vos documents d’exonération de taxes à l’aide de ce formulaire. Nous vous contacterons par e-mail dans un délai de 3 jours ouvrés afin de vous confirmer votre statut d’exonération de taxes. Après avoir reçu votre e-mail d’autorisation, les achats et renouvellements de souscriptions à venir ne seront pas taxés. Les taxes payées pour des achats effectuées avant réception de l’e-mail de confirmation d’exonération de taxes ne sont pas remboursables.",
    "yourSubmissionWasSuccessfulNew": "Soumission réussie Notre équipe va examiner vos documents et vous devriez recevoir un e-mail de notification vous confirmant que votre requête a été traitée dans un délai de 3 jours ouvrés. Une fois cette requête acceptée, vous serez en mesure de passer votre commande sans payer de taxes. En attendant, nous avons créé pour vous un compte communauté gratuit afin que vous puissiez commencer à explorer tout ce que myBoardmaker est en mesure de vous offrir.",
    "yourSubmissionWasSuccessfulExisting": "Soumission réussie Notre équipe va examiner vos documents et vous devriez recevoir un e-mail de notification vous confirmant que votre requête a été traitée dans un délai de 3 jours ouvrés. Une fois cette requête acceptée, vous serez en mesure d’effectuer votre paiement sans payer de taxes."
  },
  "modify": {
    "contactCustomerSupport": "Contactez <1>{{supportLink}}</1> pour modifier votre souscription",
    "billingDetails": "Modifier les détails de facturation",
    "paymentModalHeader": "Mise à jour réussie !",
    "paymentModalBody": "Vos modifications seront appliquées lors de votre prochain cycle de facturation.",
    "thankYou": "Nous vous remercions pour votre paiement !",
    "daysRemaining": "jours restants",
    "dueDisclaimer": "Si aucun paiement n’est reçu dans un délai de 30 jours après la date de votre renouvellement, votre compte sera automatiquement converti en compte communauté gratuit jusqu’à ce que votre solde soit payé.",
    "lateDisclaimer": "Pour éviter toute interruption de votre souscription, veuillez payer l’intégralité de votre solde. Si aucun paiement n’est reçu, votre compte sera automatiquement converti en compte communauté gratuit jusqu’à ce que votre solde soit payé.",
    "nextPaymentDueIn": "Prochain paiement à effectuer dans un délai de",
    "days": "jours",
    "paymentIs": "La date d’échéance est",
    "daysPastDue": "dépassée de jours",
    "recurringPaymentDisclaimer": "Votre <1>forfait ou souscription</1> comporte un <strong>paiement récurrent</strong> d’un montant de <4>{{amount}}</4>. Ce paiement sera renouvelé le <7>{{date, LL}}</7>.",
    "recurringPaymentDisclaimerNoPrice": "Votre forfait comporte un <strong>paiement récurrent</strong> qui sera renouvelé le <3>{{date, LL}}</3>.",
    "pastDueDisclaimer": "Vous pouvez soumettre votre bon de commande à l’aide de l’une des méthodes indiquées ci-dessous. Veuillez contacter votre service client pour réactiver votre souscription.",
    "yourAccountHasBeenConverted": "Votre compte payant a été converti en compte communauté gratuit.",
    "balanceDueIn": "Solde dû dans",
    "subscriptionExpiresIn": "La souscription expirera dans",
    "paymentPastDue": "La date limite de paiement est dépassée",
    "autoRenewal": "Renouvellement automatique",
    "turnAutoRenewOff": {
      "header": "Désactiver le renouvellement automatique de la souscription",
      "areYouSure": "Souhaitez-vous vraiment annuler le renouvellement automatique ? Procéder aura pour résultat ce qui suit :",
      "points": [
        "Annuler votre souscription payante à la fin de votre cycle de facturation actuel.",
        "Convertir votre compte en forfait communauté gratuit à la fin de votre cycle de facturation actuel.",
        "Vous pourrez accéder à votre contenu une fois que la conversion aura eu lieu et serez en mesure de vous abonner de nouveau à tout moment pour récupérer l'accès aux fonctionnalités haut de gamme qui accompagnent les souscriptions payantes. ",
        "Si vous changez d’avis avant la fin de votre souscription en cours, il vous suffit de réactiver le renouvellement automatique."
      ],
      "footer": "Souhaitez-vous désactiver le renouvellement automatique ?"
    },
    "turnAutoRenewOn": {
      "header": "Activer le renouvellement automatique de la souscription",
      "areYouSure": "Caractéristiques du renouvellement automatique de la souscription :",
      "points": [
        "Votre souscription est configurée pour être renouvelée automatiquement à la fin de la période de souscription en cours.",
        "Effectuez vos paiements facilement en utilisant vos méthodes de paiement enregistrées.",
        "Nous vous enverrons un reçu par e-mail à chaque renouvellement de votre souscription.",
        "Comme d’habitude, vous serez en mesure de modifier les paramètres de votre souscription à tout moment dans Mon forfait.",
        "Vous changez d’avis ? Désactivez la fonction Renouvellement automatique avant la fin du dernier jour de la période de souscription en cours et vous ne serez pas facturé."
      ],
      "footer": "Souhaitez-vous activer le renouvellement automatique ?"
    },
    "on": "Activé",
    "off": "Désactivé",
    "pending": "en attente",
    "plan": "Forfait",
    "term": "Échéance",
    "effective": "Effectif",
    "subscription": "Abonnement",
    "downgradeWarning": {
      "title": "Rétrograder la souscription",
      "prompt": "Voulez-vous vraiment sélectionner ce forfait ? Procéder aura pour résultat ce qui suit :",
      "planChange": "Passer d’un forfait professionnel à un forfait privé à la fin de votre cycle de facturation en cours",
      "termChange": "Passer d’un forfait annuel à un forfait mensuel à la fin de votre cycle de facturation en cours",
      "changeNote": "Vos modifications seront appliquées lors de votre prochain cycle de facturation.",
      "termChangeMultiToYearly": "Passer d’un forfait pluriannuel à un forfait annuel à la fin de votre cycle de facturation en cours",
      "termChangeMultiToMonthly": "Passer d’un forfait pluriannuel à un forfait mensuel à la fin de votre cycle de facturation en cours"
    },
    "futureAmendmentThankYou": "Ces modifications prendront effet à la fin du cycle de facturation en cours. Une facture sera disponible une fois que ces modifications auront été appliquées à votre compte. Si vous souhaitez annuler une modification en attente, veuillez appeler le <1>service client</1>.",
    "futureAmendmentDisclaimer": "Votre forfait <1>{{planName}}</1> actuel expirera le <3>{{startEndDate}}</3>. Votre nouveau forfait <5>{{selectedPlanName}}</5> commencera le <7>{{startEndDate}}</7> et sera automatiquement renouvelé le <9>{{term}}</9>.",
    "modificationPending": "Modification de forfait en attente.",
    "paymentDeclined": "Votre transaction de renouvellement de souscription a été refusée. Veuillez modifier votre méthode de paiement avant le <1>{{date}}</1> ou votre souscription sera annulée.",
    "continueSubscription": "Votre souscription expirera le <1>{{ date1 }}</1>. Si vous souhaitez renouveler votre souscription pour un autre {{term}}, veuillez activer le renouvellement automatique avant le <5>{{ date2 }}</5> et nous traiterons votre paiement le lendemain.",
    "discontinuedRatePlan": "Votre souscription en cours n'est plus disponible. Veuillez choisir une autre option.",
    "cancelYourSubscription": "Si vous souhaitez annuler votre souscription et recevoir un remboursement intégral, vous devez contacter <1>{{supportLink}}</1> avant <3>{{thirtyDayWindow}}</3>",
    "modifySubscription": "Modifier la souscription",
    "cancelCardText": "Vous pouvez annuler votre souscription à tout moment. Mais nous aimerions que vous restiez.",
    "cancelConfirmTitle": "Voulez-vous vraiment annuler votre souscription ?",
    "cancelConfirmIntro": "Votre forfait actuel restera actif jusqu'au <strong>{{date}}</strong>. Une fois votre forfait terminé :",
    "cancelConsequences": [
      "Vous perdrez l'accès aux fonctionnalités premium.",
      "Vous ne profiterez plus des avantages exclusifs offerts avec votre souscription.",
      "Les avantages de votre souscription prendront fin à l'expiration de votre forfait actuel."
    ],
    "keepSubscription": "Conserver ma souscription",
    "confirmCancel": "Non, je souhaite annuler",
    "cancelledTitle": "Votre souscription a été annulée !",
    "cancelledBody": "Votre souscription a été annulée. Vous n'aurez plus accès à votre compte premium après le {{date}}.",
    "cancelledFarewell": "Nous sommes désolés de vous voir partir ! Vous serez toujours le bienvenu.",
    "done": "Terminé",
    "cancelledNotice": "Votre souscription <strong>{{planName}}</strong> actuelle expirera le <strong>{{date}}</strong>. Renouvelez votre souscription pour continuer à profiter de nos fonctionnalités premium.",
    "resubscribedNotice": "Votre nouvelle souscription <strong>{{planName}}</strong> commence le <strong>{{date}}</strong>, à l’expiration de votre souscription actuelle."
  },
  "tdAccount": {
    "title": "Compte Tobii Dynavox",
    "header": "Qu’est-ce qu’un compte Tobii Dynavox à authentification SSO ?",
    "body": "Votre compte SSO Tobii Dynavox, dont les identifiants sont une adresse e-mail et un mot de passe, est un compte unique qui vous permettra de vous connecter à tous nos sites Web ou applications. En plus des avantages d'une sécurité améliorée, l’authentification SSO assure également un accès encore plus rapide et pratique à votre contenu au sein de tous les services de Tobii Dynavox.",
    "haveA": "Vous avez déjà",
    "tobiiDynavoxAccount": "un compte Tobii Dynavox ?"
  },
  "redirectPageTitle": {
    "homePage": "Page d'accueil",
    "profileCreation": "Création du profil"
  },
  "download": {
    "downloadBoardmaker": "Télécharger Boardmaker",
    "downloadBoardmakerStudentCenter": "Télécharger Boardmaker Student Center",
    "downloadOtherVersions": "Télécharger d’autres versions",
    "downloadBoardmakerStudio": "Télécharger Boardmaker Studio",
    "licenseKey": "Clef d'activation",
    "download": "Télécharger",
    "licenseHelper": "Aide sur la licence",
    "discontinued": "<1>{{discontinueDate}}</1> interrompu. Voir la <3>configuration système requise</3>.",
    "mainFeatures": "Fonctionnalités principales",
    "compatibility": "Compatibilité",
    "improvements": "Améliorations",
    "bugFixes": "Réparations des bugs.",
    "version": "Version",
    "discontinuedSupport": "Assistance interrompue",
    "releaseDate": "Publié le {{date}}",
    "discontinuedDate": "Interrompu {{date}}",
    "boardmakerSummary": "Sélectionnez le bouton ci-dessous pour télécharger la dernière version de Boardmaker Editor, qui est utilisée pour créer et éditer des activités.  L’installateur fonctionne avec tous les types de comptes et langues prises en charge.",
    "studentCenterSummary": "Sélectionnez le bouton ci-dessous pour télécharger la dernière version de Boardmaker Student Center, qui est utilisée pour effectuer des activités Boardmaker. L’installateur fonctionne avec tous les types de comptes et langues prises en charge.",
    "boardmakerIntro": "Boardmaker 7 Editor est le premier outil dont l’objectif est de permettre aux éducateurs, aux thérapeutes et aux parents de créer, de modifier et de partager des activités Boardmaker.  Facilitez l’apprentissage et la communication dans votre salle de classe, votre salle de thérapie ou à la maison avec une large gamme de matériel personnalisable.",
"studentCenterIntro": "Les éducateurs ont la possibilité d’attribuer des activités aux apprenants et de suivre les progrès de ces derniers dans l'application Boardmaker 7 Student Center, s’ils disposent de certains types d'abonnements Boardmaker 7.  Les apprenants peuvent utiliser l'application à la maison ou à l'école pour effectuer leurs activités.",
"boardmakerStudioIntro": "Grâce à Boardmaker Studio, les personnes qui assistent les apprenants souffrant de handicaps ont la possibilité de créer  et d’éditer des activités afin de permettre à ces derniers d’apprendre et de communiquer à l'aide de symboles, de textes et de voix de synthèse et enregistrées.",
"mobilePlayerIntro": "Les éducateurs ont la possibilité d’attribuer des activités aux apprenants et de suivre les progrès de ces derniers dans l'application Boardmaker Student Center, s’ils disposent de certains types d'abonnements myBoardmaker.  Les apprenants peuvent utiliser l'application à la maison ou à l'école pour effectuer leurs activités.",
    "communityStartHeader": [
      "Demandez votre accès à la communauté et votre stockage",
      0,
      0
    ],
    "communityStartBody": [
      "Boardmaker est conçu pour être utilisé avec Boardmakeronline.com, où vous pouvez sauvegarder vos fichiers Boardmaker personnels en toute sécurité et accéder à notre communauté mondiale. Les membres de la communauté peuvent partager ce qu’ils ont créé et trouver de nouvelles activités Boardmaker provenant d’autres utilisateurs. Inscrivez-vous pour créer un compte communauté et obtenir un accès !",
      0,
      0
    ],
    "latestMobile": "Pour une expérience optimale, veuillez essayer de télécharger le logiciel à partir d'un dispositif conforme à la configuration système exigée <1>{{systemRequirements}}</1>.",
    "downloadSystemRequirements": "Configuration système requise",
    "viewSystemRequirements": "Consultez le <1>{{guideLink}}</1> pour connaître la configuration système requise.",
    "onThisPage": "Sur cette page",
    "communityStart": {
      "header": "Demandez votre accès à la communauté et votre stockage",
      "body": "Boardmaker est conçu pour fonctionner avec myboardmaker.com. Votre compte gratuit Boardmaker Community comprend ce qui suit :",
      "pointOne": "Stockage dans le cloud - Sauvegardez en toute sécurité vos fichiers Boardmaker personnels et accédez-y n'importe où !",
      "pointTwo": "Activities-to-Go - Un programme thématique nivelé prêt à être imprimé et utilisé.",
      "pointThree": "Accédez à notre communauté mondiale - partagez ce que vous avez créé et recherchez de nouvelles activités Boardmaker créées par d'autres utilisateurs.",
      "footer": "Inscrivez-vous pour créer votre compte communauté et obtenir un accès !"
    },
    "BoardmakerCompatible": "Ce dispositif n'est pas compatible avec le logiciel Boardmaker.",
    "BoardmakerStudentCenterCompatible": "Ce dispositif n'est pas compatible avec l'application Boardmaker Student Center.",
    "BoardmakerMobile": "Ce dispositif ne prend pas en charge les applications Boardmaker."
  },
  "subscriptionLicense": {
    "toggle": {
      "subscription": "souscription",
      "tosubscriptionText": "$t(subscriptionLicense.toggle.subscription)",
      "license": "licence",
      "tolicenseText": "achat unique",
      "mainText": "Préfère un <1>{{ toggleText }}</1> ou <3>{{ helpLink }}</3> ?",
      "preferencedText": "Vous préférez un "
    },
    "comparison": {
      "accessTo": "Accéder à ce qui suit...",
      "title": "Aidez-moi à choisir",
      "titleDescription": "Un rapide coup d'œil sur les différences entre la souscription myBoardmaker et le logiciel Boarmaker lui-même.",
      "titles": {
        "investment": "Investissement",
        "includedSoftware": "Logiciel inclus",
        "softwareUpdates": "Mises à jour du logiciel",
        "pcsSymbols": "PCS Symbols",
        "cloudStorage": "Stockage sur le cloud",
        "curriculum": "Programme",
        "studentManagement": "Gestion de l’élève"
      },
      "subscription": {
        "header": "Abonnement myBoardmaker",
        "investment": "Faible coût initial, choix de paiement annuel ou mensuel",
        "includedSoftware": "Boardmaker 7, Boardmaker Student Center",
        "softwareUpdates": "Inclus (2-3 fois par an)",
        "pcsSymbols": "Tous les symboles, y compris de nouveaux symboles toutes les 2 semaines",
        "cloudStorage": ["Archive activité", "Archive média"],
        "curriculum": [
          "Boardmaker Activities to Go 10 Sujets x 4 Unités chacun",
          "Reading Avenue",
          "Core First Learning",
          "Expedition Education",
          "Book Bridge"
        ],
        "studentManagement": [
          "Affecter des activités\u00B9",
          "Suivre les performances"
        ]
      },
      "license": {
        "header": "Logiciel uniquement",
        "investment": "Achat unique du logiciel",
        "includedSoftware": "Boardmaker 7",
        "softwareUpdates": "Mises à niveau payantes périodiques (tous les 2 à 3 ans)",
        "pcsSymbols": "Tous les symboles disponibles au moment de la sortie de la dernière version (souscription PCS disponible prochainement)",
        "cloudStorage": "Archive activité",
        "curriculum": "Boardmaker Activities to Go 1 Sujet x 4 Unités",
        "studentManagement": "Aucun"
      },
      "note": "Les utilisateurs peuvent gérer et ajouter des tâches individuellement pour les élèves avec le forfait d’abonnement professionnel",
      "note2": "Accessible uniquement avec Student Center Player",
      "note3": "Les utilisateurs peuvent gérer et ajouter des tâches individuellement pour les élèves avec le forfait d’abonnement professionnel",
      "localizationNoteOne": "Les applications Boardmaker 7 sont disponibles dans les langues suivantes pour les utilisateurs bénéficiant d’une souscription et les utilisateurs permanents (logiciel uniquement)",
      "availableIn": [
        "Dansk",
        "Deutsch",
        "English (US)",
        "Español",
        "Suomi",
        "Français",
        "Italiano",
        "Norsk",
        "Polski",
        "Português (Brasil)",
        "Русский",
        "Svenska"
      ],
      "oldAvailableIn": [
        "Anglais (États-Unis)",
        "Espagnol",
        "Allemand",
        "Suédois",
        "Finlandais",
        "Russe",
        "Danois",
        "Norvégien",
        "French",
        "Italien",
        "Polonais",
        "Portugais"
      ],
      "localizationNoteTwo": "Le programme et le site myBoardmaker.com ne sont disponibles qu’en anglais."
    }
  },
  "systemRequirements": "Système nécessaire",
  "releaseNotes": "Notes de publication",
  "operatingSystem": {
    "title": "Système d'exploitation",
    "macos": "macOS",
    "chromebook": "Chromebook",
    "ios": "iPadOS",
    "android": "Android (mobile)",
    "windows": "Windows",
    "unknown": "Inconnu"
  },
  "perpetual": {
    "trial": {
      "intro": "Aucune carte de crédit. Aucun engagement Seulement <1>{{trialLength}}</1> jours consécutif d'accès sans restriction à notre dernier logiciel Boardmaker. Après avoir téléchargé et installé le logiciel sur votre ordinateur, vous pouvez demander une clef d’activation de <3>{{trialLength}}</3> jours <5>*</5> directement dans le logiciel.",
      "footnote": "<0>*</0>Les périodes d’essai démarrent le jour de l'activation de notre logiciel pour <2>{{trialLength}}</2> jours consécutifs.",
      "downloadFootnote": "<0>La v{{version}}</0> comporte les dernières fonctionnalités et corrections. Voir la <2>configuration système requise</2>."
    },
    "thankyou": {
      "intro": "Consultez votre e-mail de confirmation de commande contenant les liens de téléchargement Boardmaker et votre clef d’activation. Nous avons également fourni les informations ci-dessous. Téléchargez et installez Boardmaker sur votre ordinateur, puis utilisez la clef d'activation pour activer votre logiciel. Une fois le logiciel activé, vous recevrez 1 an de mises à jour gratuites. <1>N’oubliez pas d’enregistrer votre clé d’activation pour une utilisation ultérieure.</1>"
    },
    "latest": "Le plus récent",
    "legacy": "Ancienne version"
  },
  "countries": {
    "us": "États-Unis d’Amérique"
  },
  "currencyChange": {
    "header": "Changement de devise",
    "body": "Aucune souscription ne peut être achetée avec la devise du pays sélectionné pour le moment. Votre devise sera changée en dollars américains - USD - lors du paiement."
  },
  "partner": {
    "body": "Le partenaire choisi ou le prestataire d'assistance sera votre interlocuteur principal pour toute question et problème technique concernant le produit.",
    "contactUs": "Si le pays répertorié est incorrect, veuillez ",
    "contactCustomerService": "contacter le service client."
  }
}
